import { Events, getStaticProps } from '@public/Events'

export { getStaticProps }

export default Events
